import { AfterContentInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractBaseDetailsComponent } from '../../../core/component/abstract-base-details-component';
import { ToastrService } from 'ngx-toastr';
import { ProductModal } from '../../product/modal/product-modal';
import { Puritymodal } from '../../purity/modal/puritymodal';
import { PartyWiseSalesLedgerModel } from '../model/party-wise-sales-ledger-model';
import { UserModal } from '../../user/modal/user-modal';
import { PartyWiseSalesLedgerServiceService } from '../service/party-wise-sales-ledger-service.service';
import { SoCustomerLedgerResponseModel } from '../model/so-customer-ledger-response-model';
import { PartyModal } from '../../party/modal/party-modal';
import { SystemConfigService } from '../../../system-config/service/system-config.service';
import { SystemConfigSettingModel } from '../../../shared/model/system-config-setting-model';
import { PartyWiseSalesLedgerParamConfigModel } from '../model/party-wise-sales-ledger-param-config.model';
import { ModuleParamGlobConfigService } from '../../../core/service/moduleFieldConfig/module-param-glob-config.service';
import { SystemConfigModel } from 'src/app/system-config/model/system-config-model';
import { ResponseCode } from 'src/app/core/constant/response-code';

@Component({
  selector: 'app-party-wise-sales-ledger-view',
  templateUrl: './party-wise-sales-ledger-view.component.html',
  styleUrls: ['./party-wise-sales-ledger-view.component.css'],
})
export class PartyWiseSalesLedgerViewComponent
  extends AbstractBaseDetailsComponent
  implements OnInit, AfterContentInit {
  reqModelLedger: PartyWiseSalesLedgerModel;
  public myMath = Math;
  ledgerData: Array<SoCustomerLedgerResponseModel>;
  public isLabelSupportEnabled: any;
  productList: Array<ProductModal>;
  purityList: Array<Puritymodal>;
  statusList = [
    {
      id: 1,
      name: 'Draft',
    },
    {
      id: 3,
      name: 'In Process',
    },
    {
      id: 7,
      name: 'Completed',
    },
  ];
  @Input() salesHeadList: Array<UserModal>;
  @Input() currentSalesHead: UserModal;
  @Input() currentParty: PartyModal;
  @ViewChild('salesHeadTmp') salesTmp;
  public systemParam: SystemConfigSettingModel = new SystemConfigSettingModel(this.systemConfigService);
  public moduleParam: PartyWiseSalesLedgerParamConfigModel = new PartyWiseSalesLedgerParamConfigModel(
    this.moduleService
  );
  constructor(
    public toaster: ToastrService,
    public systemConfigService: SystemConfigService,
    private moduleService: ModuleParamGlobConfigService,
    public service: PartyWiseSalesLedgerServiceService
  ) {
    super(toaster);
  }

  ngOnInit() {
    this.setDate();
    this.getData();
    this.getList();
  }
  getList() {
    this.service.getSystemConifgData().subscribe((response) => {
      if (response.responseCode === ResponseCode.OK) {
        this.isLabelSupportEnabled = response.dataList.filter((x) => x.keyName === 'LABEL_SUPPORT' && x.value == 'YES');
      } else {
        this.toaster.error(response.responseMessage, 'error');
      }
    });
  }
  setDate() {
    if (!this.reqModelLedger) this.reqModelLedger = new PartyWiseSalesLedgerModel();
    this.reqModelLedger.startDate = new Date(new Date().setDate(new Date().getDate() - 30));
    this.reqModelLedger.endDate = new Date();
    this.reqModelLedger.status = new Array<number>();
    this.reqModelLedger.status.push(this.statusList[1].id);
    this.reqModelLedger.party = this.currentParty.id;
    if (!this.isUserAllow) {
      if (this.salesTmp) this.salesTmp.disabled = true;
      this.reqModelLedger.salesHead = new Array<number>();
      if(this.currentSalesHead)
      this.reqModelLedger.salesHead.push(this.currentSalesHead.staffid);
    }
  }

  getData() {
    this.service.getCustomerLedgerReport(this.reqModelLedger).subscribe((response) => {
      this.validateResponse(response, () => {
        this.ledgerData = new Array<SoCustomerLedgerResponseModel>();
        this.ledgerData = response.dataList;
      });
    });
  }

  ngAfterContentInit() {}

  getLabelQuantity(i: number, j: number): number {
    let needToInward = 0;
    if (this.ledgerData && this.ledgerData.length !== 0) {
      if (
        this.ledgerData[i].soCustomerLedgerDetails[j].soQty <= this.ledgerData[i].soCustomerLedgerDetails[j].labelQty
      ) {
        return needToInward;
      }
      needToInward =
        this.ledgerData[i].soCustomerLedgerDetails[j].soQty - this.ledgerData[i].soCustomerLedgerDetails[j].labelQty;
      return needToInward;
    }
    return needToInward;
  }

  onClickGoForProduction(i: number) {
    this.ledgerData[i].isReadyForProduction = !this.ledgerData[i].isReadyForProduction;
    if (this.ledgerData[i].soStatus.id === this.systemParam.statusCompletedId) {
      this.toaster.info('Order Completed Successfully !!', 'INFO');
      return (this.ledgerData[i].isReadyForProduction = true);
    }

    if (this.ledgerData[i].isReadyForProduction) {
      this.toaster.info('Order Ready for Production!!', 'Info');
      if (this.ledgerData[i].soId) this.service.readyForProduction(this.ledgerData[i].soId).subscribe();
    }
    if (!this.ledgerData[i].isReadyForProduction) {
      this.toaster.info('Order on Hold for Production!!', 'Info');
      if (this.ledgerData[i].soId) this.service.resetForProduction(this.ledgerData[i].soId).subscribe();
    }
  }

  onClickForDispatch(i: number) {
    if (this.ledgerData[i].soStatus.id === this.systemParam.statusCompletedId) {
      this.toaster.info('Order Completed Successfully !!', 'INFO');
      return (this.ledgerData[i].isReadyForDispatch = true);
    }

    if (this.ledgerData && this.ledgerData.length !== 0) {
      if (this.ledgerData[i].totalProductionQty == 0 && this.ledgerData[i].totalAvailableQty == 0) {
        return this.toaster.warning('Order not yet ready for Dispatch!!', 'Warning');
      } else {
        this.ledgerData[i].isReadyForDispatch = !this.ledgerData[i].isReadyForDispatch;
        if (this.ledgerData[i].isReadyForDispatch) {
          this.toaster.info('Order Ready for Dispatch!!', 'Info');
          if (this.ledgerData[i].soId) this.service.readyForDispatch(this.ledgerData[i].soId).subscribe();
        }
        if (!this.ledgerData[i].isReadyForDispatch) {
          this.toaster.info('Order on Hold for Dispatch!!', 'Info');
          if (this.ledgerData[i].soId) this.service.resetForDispatch(this.ledgerData[i].soId).subscribe();
        }
      }
    }
  }

  getProductionAgaintOrder(i: number): number {
    let num = 0;
    if (this.ledgerData[i].soStatus.id === this.systemParam.statusCompletedId) {
      return num;
    } else {
      num = this.ledgerData[i].totalProductionQty;
    }
    return num;
  }

  getPendingProductionAganistOrder(i: number) {
    let num = 0;
    if (this.ledgerData[i].soStatus.id === this.systemParam.statusCompletedId) {
      return num;
    } else {
      num = this.ledgerData[i].totalSOQty - this.ledgerData[i].totalProductionQty;
    }
    return num;
  }
}
